





import Chart from "chart.js/auto";
// import { DateTime } from "luxon";
// This import is required to use the timer adaptor for the chart
import "chartjs-adapter-luxon";

import mixins from "vue-typed-mixins";
import { ChartMixin } from "@/mixins/chart-mixin";

import config from "@/config";

export default mixins(ChartMixin).extend({
  name: "MixedChart",
  props: {
    chartID: {
      required: true,
      type: String,
    },
    chartTitle: {
      required: false,
      default: "",
      type: String,
    },
    stacked: {
      default: false,
      required: false,
      type: Boolean,
    },
    displayLegend: {
      required: false,
      default: false,
      type: Boolean,
    },
    timeInfo: {
      required: false,
      type: Object as () => {
        unitType?: string;
        displayFormats?: any;
        tooltipFormat?: string;
      },
      default: () => ({} as any),
    },
    rangeValues: {
      required: false,
      type: Object as () => {
        max: number;
        min: number;
      },
      default: () => ({
        max: 0,
        min: 0,
      }),
    },
    chartLabels: {
      required: false,
      type: Array as () => string[],
      default: () => [],
    },
    chartInfo: {
      required: true,
      type: Object as () => {
        data: [];
        labels?: [];
        // these can be either an object with 2 values (for gradient) or a string
        colors: [];
      },
    },
  },
  data() {
    return {
      chartRef: undefined as any,
    };
  },
  mounted() {
    const curCanvas: HTMLCanvasElement = document.getElementById(
      this.chartID
    ) as HTMLCanvasElement;

    const options = this.getBarChartOption({
      chartId: this.chartID,
      min: this.rangeValues.min,
      max: this.rangeValues.max,
      isStacked: this.stacked,
      unitType: this.timeInfo.unitType,
      displayFormats: this.timeInfo.displayFormats,
      tooltipFormat: this.timeInfo.tooltipFormat,
      chartTitle: this.chartTitle,
      hasLegend: this.displayLegend,
    });

    const chartData = this.formatChartData();
    this.chartRef = new Chart(curCanvas, {
      type: "bar",
      data: {
        labels: config.daysWeekPT,
        datasets: [
          {
            data: chartData[0],
            backgroundColor: chartData[0].backgroundColor,
            borderColor: chartData[0].borderColor,
            label: chartData[0].label,
            type: "bar",
          },
          // {
          //   data: chartData[1].data,
          //   backgroundColor: chartData[1].backgroundColor,
          //   borderColor: chartData[1].borderColor,
          //   order: 2,
          //   label: chartData[1].label,
          //   type: "line",
          // },
          {
            type: "line",
            data: chartData[1].data,
            borderColor: chartData[1].borderColor,
            fill: chartData[1].backgroundColor,
            label: chartData[1].label,
            order: 1,
          },
        ],
        // datasets: chartData,
      },
      options: options,
      plugins: [this.externalLegendHandler()],
    });
  },
  methods: {
    formatChartData() {
      const chartData = [];
      for (let i = 0; i < this.chartInfo.data.length; i++) {
        const curColor: any = this.chartInfo.colors[i];
        const curLabels = this.chartInfo.labels;

        if (!curColor || !curColor.border) {
          continue;
        }

        const tempData = {
          data: this.chartInfo.data[i],
          backgroundColor: curColor.border,

          label: curLabels && curLabels.length ? curLabels[i] : "",
          borderColor: curColor.border,
          tension: 0.4,
          //   borderRadius: i == 2 ? null : 5,
          type: i == 2 ? "line" : "bar",
        };

        chartData.push(tempData);
      }
      return chartData;
    },
    forceUpdateChart() {
      this.chartRef.data.datasets = this.formatChartData();
      this.chartRef.data.labels = this.chartLabels;
      this.chartRef.options = this.getBarChartOption({
        chartId: this.chartID,
        min: this.rangeValues.min,
        max: this.rangeValues.max,
        isStacked: this.stacked,
        unitType: this.timeInfo.unitType,
        displayFormats: this.timeInfo.displayFormats,
        tooltipFormat: this.timeInfo.tooltipFormat,
        chartTitle: this.chartTitle,
        hasLegend: this.displayLegend,
      });
      this.chartRef.update();
    },
  },
  // chart graphics don't update when most of it's properties change so it is required to
  // force rerendering whenever these changes happen. For this case, it is required to do so
  // when there are data changes or label information
  watch: {
    "chartInfo.data"(newValue) {
      this.forceUpdateChart();
    },
    chartLabels(newValue) {
      this.forceUpdateChart();
    },
  },
});
